import { useCallback, useMemo } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import { ROUTES } from '../../../shared/config/routes';
import { selectAuthTenantName, selectAuthUser } from '../store/authSlice';

export function useHeaderAuth() {
  const { logout } = useAuth0();
  const storedUser = useSelector(selectAuthUser);
  const tenantName = useSelector(selectAuthTenantName);

  const displayName = useMemo(
    () => [storedUser?.first_name, storedUser?.last_name].filter(Boolean).join(' '),
    [storedUser?.first_name, storedUser?.last_name],
  );

  const logoutToRoot = useCallback(
    () =>
      logout({
        logoutParams: {
          returnTo: `${window.location.origin}${ROUTES.ROOT}`,
        },
      }),
    [logout],
  );

  return { displayName, tenantName, logoutToRoot };
}
